<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Colaborador
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
          </div>
        </div>
        <sys-form :inputs="colaborator_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'colaborators' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import colabsService from '@/services/colaborators'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'ColaboratorCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      colaborator_details: {
        position: {
          name: 'Puesto',
          value: '',
          type: 'datalist',
          size: 12,
          validate: 'required'
        },
        name: {
          name: 'Nombre',
          hint: 'Nombre',
          value: '',
          type: 'text',
          validate: 'required'
        },
        lastname_father: {
          name: 'Apellido Paterno',
          hint: 'Apellido Paterno',
          value: '',
          type: 'text',
          validate: 'required'
        },
        lastname_mother: {
          name: 'Apellido Materno',
          hint: 'Apellido Materno',
          value: '',
          type: 'text',
          validate: 'required'
        },
        email: {
          name: 'Correo',
          hint: 'Correo',
          value: '',
          type: 'email'
        },
        telephone: {
          name: 'Teléfono',
          hint: 'Teléfono',
          value: '',
          type: 'text'
        },
        status: {
          name: 'Estatus',
          value: '',
          type: 'select',
          options: [
            { value: 'Activo', text: 'Activo', selected: true },
            { value: 'Inactivo', text: 'Inactivo' }
          ]
        },
        dob: {
          name: 'Fecha de Nacimiento',
          value: '',
          type: 'date'
        },
        start_date: {
          name: 'Fecha Inicio',
          value: '',
          type: 'date'
        },
        salary: {
          name: 'Salario',
          hint: 'Salario',
          value: '',
          type: 'number'
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    colabsService.getPositionsList().then(res => {
      this.colaborator_details.position.items = res.data
      this.loaded = true
    })
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let colaboratorInfo = { ...this.colaborator_details }

          let body = this.processForm(colaboratorInfo)
          let service = colabsService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'colaborators', props: { colaborator: res } })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/colaborators/ColaboratorCreate.vue